"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross4"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var List = function List(props) {
  var list = props.list,
    selected = props.selected,
    toggle = props.toggle;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showSelected = _useState4[0],
    setShowSelected = _useState4[1];
  var filteredList = (0, _react.useMemo)(function () {
    return list.filter(function (item) {
      if (showSelected && !selected.has(item.id)) {
        return false;
      }
      if (search && !item.id.includes(search)) {
        return false;
      }
      return true;
    });
  }, [list, search, selected, showSelected]);
  var selectAll = function selectAll() {
    toggle(filteredList.filter(function (item) {
      return !selected.has(item.id);
    }).map(function (item) {
      return item.id;
    }));
  };
  var selectNone = function selectNone() {
    toggle(filteredList.filter(function (item) {
      return selected.has(item.id);
    }).map(function (item) {
      return item.id;
    }));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].listWrapper
  }, list.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonArea
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].searchArea
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: (0, _classnames2["default"])('form-control form-control-sm', _defineProperty({}, _style["default"].filled, Boolean(search))),
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    placeholder: "Search..."
  }), search ? /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].clear,
    onClick: function onClick() {
      return setSearch('');
    }
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)) : null), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-sm",
    onClick: selectAll
  }, "Select all"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary btn-sm",
    onClick: selectNone
  }, "Select none"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-check ms-2"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-check-label"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    checked: showSelected,
    onChange: function onChange() {
      return setShowSelected(!showSelected);
    }
  }), ' ', "show selected only"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, filteredList.length === 0 && 'No metrics', filteredList.map(function (item) {
    var tooltip = item.label || item.question;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: item.id,
      className: "form-check"
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-check-label"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-check-input",
      type: "checkbox",
      checked: selected.has(item.id),
      onChange: function onChange() {
        return toggle(item.id);
      }
    }), ' ', item.id, tooltip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: tooltip
    }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
      spaceLeft: true
    }))));
  })));
};
List.propTypes = {
  list: _propTypes["default"].array,
  selected: _propTypes["default"].object,
  toggle: _propTypes["default"].func
};
var _default = exports["default"] = List;